<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Pet
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Pet
              li.breadcrumb-item.active Cadastro
              
      .row.clearfix
        .col-lg-12.col-md-12.col-sm-12
          .card
            .header
              ul.header-dropdown
                li
                  router-link(:to="{ name: 'dweller.pets.index' }")
                    i.zmdi.zmdi-format-list-numbered
            .body
              .row.clearfix
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.tower_id.$error ? 'error' : null")
                      f-select(
                        name="tower_id",
                        v-model="pet.tower_id",
                        placeholder="Selecionar Torre"
                        :searchable="true",
                        :options="dwellerTowers",
                        label-by="number",
                        @selected="selectUnitsTower"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.unit_id.$error ? 'error' : null")
                      f-select(
                        name="unit_id",
                        v-model="pet.unit_id",
                        :searchable="true",
                        :multiple="false"
                        placeholder="Selecionar unidade"
                        :options="dwellerUnits",
                        label-by="number"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.species.$error ? 'error' : null")
                      f-select(
                        name="species",
                        v-model="pet.species",
                        :searchable="true",
                        :multiple="false"
                        placeholder="Selecionar Porte"
                        :options="optionSpecies",
                        label-by="label"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.name.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Nome',
                        v-model="pet.name"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.breed.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Raça',
                        v-model="pet.breed"
                      )
                .col-lg-4.col-md-4
                  .form-group
                    v-input(:status="$v.pet.color.$error ? 'error' : null")
                      input.form-control(
                        type='text',
                        placeholder='Cor',
                        v-model="pet.color"
                      )
                .col-md-12
                  button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                    type='button',
                    @click.prevent="doSave()",
                  ) Salvar
</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/dweller/pets/form/form.vue